import img1 from "./Assets/Images/1.jpg";
import img2 from "./Assets/Images/2.jpg";
import img3 from "./Assets/Images/3.jpg";
import img4 from "./Assets/Images/4.jpg";
import img5 from "./Assets/Images/5.jpg";
import img6 from "./Assets/Images/6.jpg";
import img7 from "./Assets/Images/7.jpg";
import img8 from "./Assets/Images/8.jpg";

export const WinterTourData = [
  {
    id: 1,
    img: img1,
    date: "05",
    month: "May",
    price: 60000,
    detail: "5 Days and 4 Nights Trip to Skardu by Air.",
    path: "/5-days-trip-to-skardu-by-air",
  },
  {
    id: 2,
    img: img2,
    date: "25",
    month: "May",
    price: 60000,
    detail: "7 Days and 6 Nights Luxury WinterHunza Road Trip.",
    path: "/7-days-luxury-Winterhunza-road-trip",
  },
  {
    id: 3,
    img: img3,
    date: "01",
    month: "June",
    price: 20000,
    detail: "3 Days and 2Night Arrang Kel Tour",
    path: "/3-days-arrang-kel-tour",
  },
  {
    id: 4,
    img: img4,
    date: "20",
    month: "June",
    price: 40000,
    detail: "3 Days and 2 Nights Naran Group Tour",
    path: "/3-days-naran-group-tour",
  },
  {
    id: 5,
    img: img5,
    date: "09",
    month: "July",
    price: 85000,
    detail: "7 Days and 6 Nights Swat Kashmir Tour Package",
    path: "/swat-kashmir-tour-package",
  },
  {
    id: 6,
    img: img6,
    date: "29",
    month: "July",
    price: 90000,
    detail: "7 Days and 6 Nights Chitral Kalash Tour by air",
    path: "/chitral-kalash-tour-by-air",
  },
  {
    id: 7,
    img: img7,
    date: "08",
    month: "Aug",
    price: 50000,
    detail: "3 Days and 2 Nights Ratti Gali Lake Tour ",
    path: "/ratti-gali-lake-tour",
  },
  {
    id: 8,
    img: img8,
    date: "19",
    month: "Aug",
    price: 156000,
    detail: "7 Days and 6 Night Neelum Valley Tour",
    path: "/7-days-neelum-valley-tour",
  },
];
